<template>
	<transition name="modal">
		<div class="modal-mask deleteModal">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">{{headerMssg}}</h5>
					</div>
					<div class="modal-body">
						<!-- <p>Are you sure, you want to delete?</p> -->
						<p>{{deleteMessage}}</p>
						<span v-if="supportMssg" class="no-data-style">{{supportMssg}}</span>
					</div>
					<!-- <div class="modal-footer" style = "display: flex ; justify-content : center; border : none">
				   <button type="button"
				   		@click="hideDetailsModal()"
						class="btn btn-secondary"
						style = "color : red"
						data-dismiss="modal">Cancel</button>
				   <button
					 type="button"
					 class="btn btn-primary"
					 style = "background-color : red"
					 @click = "deleteData()"
				   >Delete</button>
					</div>-->
					<div class="modal-footer" style="display: flex ; justify-content : center;">
						<button type="button" class="btn btn-secondary" @click="hideDeleteModal()">No</button>
						<button type="button" @click="deleteData()" class="btn btn-primary">Yes</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name: "DeletePopUp",
		props: {
			deleteMessage: {
				type: String,
				required: false,
				default: "Are you sure, you want to delete?"
			},
			supportMssg: {
				type: String,
				required: false,
				default: ""
			},
			headerMssg: {
				type: String,
				required: false,
				default: "Delete"
			}
		},
		methods: {
			hideDeleteModal() {
				this.$emit("hideDeleteModal", false);
			},
			deleteData() {
				this.$emit("deleteData", false);
			}
		}
	};
</script>

<style lang="scss">
.deleteModal .mso-popover-style {
	/* display : flex;
  justify-content: center;
  align-items: center; */
}
/* .popover.fade.show.bs-popover-left {
   max-width : 310px !important
} */

.deleteModal {
	.modal-mask {
		position: fixed;
		z-index: 9998;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: table;
		transition: opacity 0.3s ease;
	}
}

.deleteModal {
	.modal-wrapper {
		display: table-cell;
		vertical-align: middle;
	}
	.modal-container {
		width: 100%;
		max-width: 800px;
		margin: 0px auto;
		padding-top: 0px;
		background-color: #fff;
		border-radius: 0.3rem;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}
	.modal-enter {
		opacity: 0;
		.modal-container{
			-webkit-transform: scale(1.1);
			transform: scale(1.1);
		}
	}
	.modal-leave-active {
		opacity: 0;
		.modal-container {
			-webkit-transform: scale(1.1);
			transform: scale(1.1);
		}
	}
	.modal-title {
		text-align: center;
	}
}


</style>
